import ExpandMore from '@mui/icons-material/ExpandMore';
import AppBar from '@mui/material/AppBar';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Illustration } from '../image/Illustration';
import Progress from '../progress/Progress';
import "./Header.css";

function Header() {
    const { t, i18n } = useTranslation()

    useEffect(() => {
        i18n.changeLanguage(i18n.resolvedLanguage);
    }, [])

    return (
        <>
            <AppBar position="fixed" color="inherit">
                <Toolbar>
                    <a className="home-link" href="/">
                        <Illustration className="logo-header" src={process.env.PUBLIC_URL + "/TotalEnergies-logo.svg"} alt="TotalEnergies logo" />
                        <Typography variant="h4" flexGrow={"1"}>{t("header.title")}</Typography>
                    </a>
                    <Select
                        className='language-select'
                        variant='standard'
                        size='small'
                        disableUnderline
                        value={i18n.resolvedLanguage}
                        onChange={(e) => i18n.changeLanguage(e.target.value)}
                        IconComponent={ExpandMore}>
                        <MenuItem value="fr">FR</MenuItem>
                        <MenuItem value="en">EN</MenuItem>
                    </Select>
                </Toolbar>
                <Progress />
            </AppBar>
        </>
    )
}

export default Header;